// extracted by mini-css-extract-plugin
export default {"container":"custom_toast_container-module__container--3eRSD","material-icons":"custom_toast_container-module__material-icons--1DlpT"};